import { cn } from '../../utils/cn'

/** Thin indeterminate loading bar — a sliding highlight over a track, for in-progress feedback. */
export function IndeterminateLoadingBar({ className }: { className?: string }) {
  return (
    <div className={cn('bg-ink-100 relative h-1 overflow-hidden', className)}>
      <div className="bg-brand-700 indeterminate-bar-slide absolute inset-y-0 w-1/3 rounded-full" />
      <style>
        {`
          @keyframes indeterminate-bar-slide {
            0% { left: -33%; }
            100% { left: 100%; }
          }
          .indeterminate-bar-slide {
            animation: indeterminate-bar-slide 1.4s ease-in-out infinite;
          }
        `}
      </style>
    </div>
  )
}
